export const staff = [
  {
    name: 'Dr. Boris Havkin, MD',
    role: 'Board-Certified Urologist',
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/cahm80lh_Dr.Boris%20Havkin%2C%20MD_b%26w.jpg',
    bio: 'Dr. Havkin has been delivering highest quality, highly personalized urological care and men\'s healthcare since 1998. In the first half of his career, he focused on minimally invasive oncological care, including laparoscopic and robotic surgery with high focus on technical innovation, female pelvic reconstruction surgery combined with highly personalized restorative men\'s health practice. After over 20 years in practice, Dr. Havkin has narrowed his focus to outpatient high end men\'s health practice, including screening, diagnoses and early stages of treatment of all male cancers, but particularly specializing and focusing on delivery of high-quality care in men\'s health, including hormonal management, nutritional management (including but not limited to TRT), management of lower urinary tract disease, including but not limited to BPH (prostate enlargement), OAB (overactive bladder), incontinence, lower urinary tract symptoms, recurrent infectious processes, difficult to treat prostatitis as well as aggressive care of sexual dysfunction, including erectile dysfunction, Peyronie\'s disease, ejaculatory dysfunction, testosterone deficiency, gynecomastia, orgasmic dysfunction, premature ejaculation, delayed ejaculation etc. Dr. Havkin practices diagnosis and management of recurrent stone disease. Practice also includes management of family planning with high-quality and painless vasectomy. Dr. Havkin\'s expertise comes after many years of education starting with Summa Cum Laude BS in Biology from City University of New York in Brooklyn College followed by MD in Downstate Health Sciences University Medical College in New York City and subsequent six years of Surgical Urological Residency training in Upstate Medical University in Syracuse, New York. He is Board certified by National Board of Physicians and Surgeons. He has practiced in Melbourne, FL since 2004. He served as a Urological surgeon specializing in Minimally invasive robotic and laparoscopic oncology and reconstruction, Female pelvic reconstruction, Urological prosthetics, complex stone disease management, HRT, Sexual dysfunction in MIMA Medical Group until 2016. He has begun operating highly regarded Havkin Urology since 06/2016. Dr. Havkin has been described as a doctor\'s doctor and has been honored to be trusted to provide high quality care to many of his respected colleagues in Brevard medical community.',
  },
  {
    name: 'Ronda Sheppard, AA (BS in progress)',
    role: 'Office Manager',
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/zg3ixqdi_Ronda%20Sheppard_b%26w.jpg',
    bio: 'Ronda oversees the daily operations of our practice, ensuring that every patient receives exceptional service from the moment they walk through the doors. She served in the United States Air Force and during that time she attended CCAF and completed her AA. Ronda moved to Melbourne in 1998 and has worked in the medical field since. She has over 25+ years of experience in healthcare and has worked in numerous specialties with her primary focus in Urology. Ronda has managed Havkin Urology for the last 10 years. Her dedication to efficiency and patient satisfaction keeps our office running smoothly.',
  },
  {
    name: 'Natalie Havkin, MS CCC/SLP',
    role: 'Practice Consultant',
    phone: null,
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/79fsziby_Natalie%20Havkin%2C%20MS%20CCC_SLP_b%26w.jpg',
    bio: 'Graduate of Columbia University in New York City having moved to Upstate New York for extensive 6 year post graduate medical training in the department of ENT, SUNY Upstate Medical University. Relocated to sunny Florida in 2004. Has 22 years experience in the medical field specializing in nutrition, hormonal imbalances, and healthy lifestyle. Has been a part of Team Havkin for 10 years.',
  },
  {
    name: 'Christina Head, RMA, CNS',
    role: 'Head Clinical Nurse',
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/ziqzb1u4_Christina%20Head_b%26w.jpg',
    bio: 'I hold a two-year Medical Associate\'s degree from Keiser University and am a local graduate of Eau Gallie High School. I have over 15 years of experience working alongside Dr. Havkin, starting at age 21. As the clinical lead, I provide full clinical support, from assisting with in-office procedures and patient care to managing charting and labs. I\'m cross-trained in both clinical and clerical roles and help keep patient flow running smoothly throughout the office. Outside of work, I enjoy concerts when I can. Taylor Swift is usually playing in the background... long story short, I\'m a big fan. I also stay involved in the All-Star cheer world and, after years around the sport, hope to one day be on the judge\'s side of the table.',
  },
  {
    name: 'Shannon Holak',
    role: 'Front Desk/Patient Coordinator',
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/bue7ruwh_Shannon%20Holak_b%26w.jpg',
    bio: 'Formerly with MIMA/Healthfirst. 15+ years experience in the medical field ranging from medical records to medical secretary. Has been a part of Havkin Urology since 2019.',
  },
  {
    name: 'Dawn Matrigali, RMA, CNS (RN/BSN in progress)',
    role: 'Urodynamics Specialist',
    image: 'https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/s5gbs1w4_Dawn%20Matrigali_b%26w.jpg',
    bio: 'Educated at Indian River State College in nursing and currently pursuing a BSN bridge to ARNP at Eastern Florida State College, she brings a well-rounded clinical background with 3 years in cardiology, 7 years in pediatrics, and 20 years in urology. Has been a valued member of Team Havkin since 2018, continuing her work alongside Dr. Havkin from their time at MIMA. Enjoys spending time outdoors and has a deep love for animals.',
  },
];

export const serviceDescriptions = [
  {
    title: 'Male Sexual Health',
    items: [
      'Full spectrum of care for Hypogonadism (Low T) including Testopel testosterone pellets and compounded T pellets',
      'Full spectrum of care for Erectile Dysfunction including injections and penile prosthetic surgery (penile implants)',
      'Treatment of orgasmic dysfunction',
      'Premature ejaculation',
    ],
    path: '/services/erectile-dysfunction',
  },
  {
    title: 'Voiding Dysfunction (Trouble with Urination)',
    items: [
      'Full Spectrum of care for BPH (Enlarged Prostate) including Minimally Invasive Therapy (UroLift, Microwave Therapy, TUMT) and all forms of surgery including Robotic Surgery (Da Vinci)',
      'Full Spectrum of care for OAB (Gotta-go-bladder) including InterStim, Botox, medical therapy and physical therapy',
      'Full Spectrum of care for Male and Female urinary incontinence including all forms of surgery and minimally invasive therapy',
      'All forms of therapy for Nocturia (excessive night time urination)',
    ],
    path: '/services/bph',
  },
  {
    title: 'Stone Disease',
    items: [
      'All forms of stone surgery including Laser and Shock Wave (ESWL) as well as PCNL for very large stones',
      'Stone prevention and metabolic work up',
    ],
    path: '/services/urodynamics',
  },
  {
    title: 'All Scrotal Surgery Including Scrotaplasty, In-Office Vasectomy',
    items: [
      'Repair of Hydrocele',
      'Repair of Spermatocele',
      'Scrotoplasty (cosmetic altering of redundant scrotum)',
      'Vasectomy',
    ],
    path: '/services/vasectomy',
  },
];

export const cancerServices = [
  {
    title: 'Bladder Cancer',
    items: [
      'Diagnosis and treatment',
      'In office bladder biopsies and minimally invasive treatments',
      'Bladder Resection',
      'Radical Bladder Surgery including Robotic Surgery',
      'BCG and Mitomycin',
      'Routine State of the Art surveillance',
    ],
  },
  {
    title: 'Kidney Cancer',
    items: [
      'State of the Art diagnosis and therapy',
      'Radical Laparoscopic Nephrectomy',
      'Partial Robotic Nephrectomy',
      'Laparoscopic Nephro-ureterectomy',
      'Robotic/Laparoscopic cryoablation',
    ],
  },
  {
    title: 'Prostate Cancer',
    items: [
      'State of the Art Diagnosis and Treatment',
      'In office prostate biopsy',
      'Genomic testing',
      'Prostate Cryoablation (total and focal)',
      'Da Vinci Robotic Prostatectomy',
      'Long term follow up and care',
    ],
  },
  {
    title: 'Testicular Cancer and Adrenal Masses',
    items: [
      'Laparoscopic and/or Robotic adrenalectomy',
      'Radical Orchiectomy',
    ],
  },
];

export const awards = [
  { title: 'Patient Choice Award', org: 'Annual Recipient', year: '2008 – Present' },
  { title: 'Compassionate Doctor Award', org: 'Annual Recipient', year: '2010 – Present' },
  { title: 'Board Certified Urologist', org: 'National Board of Physicians and Surgeons', year: 'Current' },
];

export const testimonials = [
  {
    text: 'Dr Havkin is one of the most sincere, empathic, knowledgeable physicians in the area of Urology I have ever met. He spends the time with you that one may need to make a decision regarding your prostate.',
    author: 'Michael V.',
    rating: 5,
  },
  {
    text: 'Dr. Havkin - Many thanks to you and Christina for accommodating me into your schedule. You are knowledgeable, courteous, punctual, and I appreciated the education you gave me. Most of all, you are a fantastic listener to your patients.',
    author: 'KimK',
    rating: 5,
  },
  {
    text: 'Dr Havkin was much more than I expected! He was incredibly thorough and genuinely concerned about my health. He asked a lot of questions and spent time listening to my answers and story. He did not seem rushed and I felt very confident.',
    author: 'Verified Patient',
    rating: 5,
  },
  {
    text: 'Low-T and BPH. He fixed them both. This has changed my life. I have energy and flexibility and mental acuteness and stamina. I can sleep through the night. My bloodwork is excellent. And, he\'s a great guy.',
    author: 'Verified Patient',
    rating: 5,
  },
  {
    text: 'Doctor Havkin, Thank you! You are a Godsend and a true expert urologist! Your kindness, patience and expertise in diagnosing and treating my issue is a blessing! Your staff is impressive, caring and easy to deal with.',
    author: 'Bryan C.',
    rating: 5,
  },
  {
    text: 'His staff makes you feel welcome to the point you feel like family. He\'s a doctor that really cares for people. His patient care is unmatched. His staff is fantastic.',
    author: 'George G.',
    rating: 5,
  },
];
